import { Component } from '@angular/core';

@Component({
  selector: 'app-logo',
  imports: [],
  template: `<div>
  <img src="images/logo.png" width="250" />
</div>
`
})
export class LogoComponent {

}
